




















import { Component, Vue, Watch, Prop } from "vue-property-decorator";
import GenericBTable from "@/core/Generics/GenericBTable";
import { BTableColumnType } from "@/enums/BTableColumnType";
import { PermissionValue } from "@/enums/PermissionValue";
import { RowTable } from "@/typings/BRowTable";
import BTableColumn from "@/models/base/BTableColumn.model";
import BaseVue from '../../core/BaseVue';
import UserService from '@/services/user.service';
import ResearchCenterBasicInformationComponent from "@/components/research-center-basic-information/researchCenterBasicInformation.vue";
import PorposalUserReportEvaluations from '../../models/porposal/porposalUserReportEvaluations.model';
import PorposalPendingReportEvaluationTable from '@/components/pendingReportEvaluationByType/table.vue'
import { ProposalReportEvaluationType } from '@/enums/ProposalReportEvaluationType';

@Component({
    components : {
        ResearchCenterBasicInformationComponent,
        PorposalPendingReportEvaluationTable
    }
})
export default class PorposalPendingReportEvaluations extends GenericBTable<PorposalUserReportEvaluations> {
    
    budgetEvaluation:ProposalReportEvaluationType = ProposalReportEvaluationType.BudgetEvaluation;
    reportEvaluation:ProposalReportEvaluationType = ProposalReportEvaluationType.ReportEvaluation;
}
